import { AVAILABLE_REPORT_ACTIONS_API } from 'constants/AppConstants';
import { retryAPI } from 'utils/app.utils';

export default async (reportIds) => {
  try {
    const response = await retryAPI(() => fetch(AVAILABLE_REPORT_ACTIONS_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reportIds }),
    }));

    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
